import React, { PureComponent } from 'react';
import T from 'prop-types';
import PeaksLoader from './peaks-loader';
import Peaks from './peaks';
import Canvas from './components/canvas';

export default class Waveform extends PureComponent {
  state = {
    peaks: undefined,
  };

  constructor(props) {
    super(props);

    this.peaksLoader = new PeaksLoader();
  }

  componentDidMount() {
    this.maybeLoadPeakFile();
  }

  componentDidUpdate(prevProps) {
    const isNewFile = prevProps.mediaUrl !== this.props.mediaUrl;
    if (isNewFile) {
      this.maybeLoadPeakFile();
    }
  }

  componentWillUnmount() {
    if (this.peaksLoader.pending) {
      this.peaksLoader.abort();
    }
  }

  handlePeakFileLoaded = (err, buffer) => {
    this.setState({
      peaks: !err && buffer ? new Peaks(buffer, this.props.episodeDuration) : undefined,
    });
  };

  maybeLoadPeakFile() {
    const { mediaUrl } = this.props;
    if (mediaUrl) {
      if (this.peaksLoader.pending) {
        this.peaksLoader.abort();
      }

      const peakFileUrl = `${mediaUrl.substring(0, mediaUrl.lastIndexOf('.'))}.dat`;
      this.peaksLoader.load(peakFileUrl, this.handlePeakFileLoaded);
    }
  }

  render() {
    const { peaks } = this.state;
    const { episodeDuration, audioProgress } = this.props;
    const progress = episodeDuration ? audioProgress / episodeDuration : 0;

    return (
      <div className="acast-audio-waveform" ref={this.setContainer}>
        <div className="acast-waveform">
          {peaks && <Canvas width={this.props.width} progress={progress} peaks={peaks} />}
        </div>
      </div>
    );
  }
}

Waveform.defaultProps = {
  mediaUrl: undefined,
  episodeDuration: 0,
};

Waveform.propTypes = {
  width: T.number.isRequired,
  mediaUrl: T.string,
  episodeDuration: T.number,
};
